import React, { useMemo } from 'react';
import Gallery from 'react-grid-gallery';
import { keywords, SeoHeader } from "./Seo";
import { getGalleryImages } from './data/galleryData';

/**
 * PicGallery Component
 * Optimized to use data-driven approach instead of hardcoded requires
 * Images are dynamically loaded based on configuration
 */
const PicGallery = () => {
    // Memoize image array to prevent unnecessary re-renders
    const images = useMemo(() => getGalleryImages(keywords), []);

    return (
        <section id={'gallery'} className="gallery_bg">
            <div className='container'>
                <div className='row'>
                    <div className="col-sm-12 col-lg-12">
                        <h2 className="main_title black text-center mb-4">Image GALLERY</h2>
                        <SeoHeader />
                        <Gallery images={images} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PicGallery;
